import { IGeolocation } from "@origin-digital/event-dispatcher";

interface GeoIpCityResponse {
  subdivisions?: Array<{ iso_code: string }>;
  postal?: { code: string };
}
/**
 * Globally install the MaxMind GeoIP script for use.
 * Refer https://www.npmjs.com/package/@maxmind/geoip2-node
 * Refer https://dev.maxmind.com/geoip/geolocate-an-ip/client-side-javascript
 * @returns {Promise}
 */
const MAXMIND_SCRIPT_SRC = "//js.maxmind.com/js/apis/geoip2/v2.1/geoip2.js";
function loadGeoTargetingApi() {
  return new Promise((resolve, reject) => {
    const maxmindScriptTag = document.createElement("script");
    maxmindScriptTag.setAttribute("src", MAXMIND_SCRIPT_SRC);
    maxmindScriptTag.setAttribute("async", "true");
    maxmindScriptTag.addEventListener("load", resolve);
    maxmindScriptTag.addEventListener("error", reject);
    document.body.appendChild(maxmindScriptTag);
  });
}

/**
 * @returns {Promise.<global.geoip2>}
 */
async function getGeoTargetingApi() {
  // @ts-ignore
  if (!global.geoip2) {
    await loadGeoTargetingApi();
  }
  // @ts-ignore
  return Promise.resolve(global.geoip2);
}

/**
 * @returns {Promise.<geoTargetResponse>}
 */
async function getUserLocation() {
  const geoTargetingApi = await getGeoTargetingApi();

  return new Promise<GeoIpCityResponse>((resolve, reject) => {
    geoTargetingApi.city(resolve, reject);
  });
}

export const getUserGeolocation = async (): Promise<IGeolocation> => {
  const location: GeoIpCityResponse = await getUserLocation();
  const state = location?.subdivisions?.at(0)?.iso_code;
  const postcode = location?.postal?.code;
  const geolocation = { state, postcode } as IGeolocation;
  return Promise.resolve(geolocation);
};
